export enum UserType {
    CASHIER = 'cashier',
    CUSTOMER = 'customer'
}